// extracted by mini-css-extract-plugin
export default {"wrap":"zw-z","logoContainer":"Aw-z","brandImg":"Bw-z","logoImg":"Cw-z","logoButton":"Dw-z"};